import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Icon, Tooltip, Slider, Row, Col, InputNumber, Radio, Input, Switch } from 'antd';
import Countdown from 'react-countdown-now';
import NavViews from '../../stores/NavViews';
import { getSingleEvent } from '../../api-calls/events';
import { FaUserSecret } from 'react-icons/fa';
const RadioGroup = Radio.Group;
const ethMultiplier = 1000000000000000000;
@observer(["BetSlipStore", "CustomRouter", "TeamStore"])
class BetSlipWager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            teamOneName: "",
            teamTwoName: "",
            selectedTeamName: this.props.wager.selectedTeam,
            valueClicked: false,
            oddsClicked: false,
            inputValue: 1,
            radioValue: 1,
            oneToBlankOddsValue: 100,
            blankToOneOddsValue: 100,
            propTitle: "",
            isPrivate: false,
        };

        this.handleClickValue = this.handleClickValue.bind(this);
        this.handleClickOdds = this.handleClickOdds.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOddsChange = this.handleOddsChange.bind(this);
        this.handleKeyPressValue = this.handleKeyPressValue.bind(this);
        this.handleKeyPressOdds = this.handleKeyPressOdds.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onPrivateSwitchChange = this.onPrivateSwitchChange.bind(this);
    }

    round(value) {
        return Math.round(value * 100) / 100;
    }

    async componentWillMount() {
        const { TeamStore } = this.props;

        TeamStore.queryTeams();
    }

    async componentDidMount() {
        const {
            wager,
            TeamStore
        } = this.props;

        //console.log("teams: " + JSON.stringify(TeamStore));

        let self = this;
        setTimeout(() => {
            TeamStore.teams.forEach(function (team) {
                if (wager.team_one == team._id) {
                    self.setState({
                        teamOneName: team.name
                    });
                }
                if (wager.team_two == team._id) {
                    self.setState({
                        teamTwoName: team.name
                    });
                }
                if (wager.selectedTeam == team._id) {
                    self.setState({
                        selectedTeamName: team.name
                    });
                }
            });
            wager.setOdds(100);
            //   console.log("teams from slip: " + JSON.stringify(TeamStore));

        }, 30);

        if (wager.isPropWager) {
            setTimeout(() => {
                getSingleEvent(wager.eventId).then((propEvent) => {
                    self.setState({ propTitle: propEvent.propTitle });
                })
            }, 100);
        }
    }

    handleClickValue() {
        this.setState({ valueClicked: !this.state.valueClicked })
    }

    handleClickOdds() {
        this.setState({ oddsClicked: !this.state.oddsClicked })
    }

    handleValueChange(e) {
        const { wager } = this.props;

        //console.log(parseFloat(e.target.value, 10));

        if (e !== "") {


            wager.setValue(Number(e));

        }

    }

    handleOddsChange(e) {
        const { wager } = this.props;
        let inputValue = e.target.value * 100;

        console.log(parseFloat(inputValue, 10));

        wager.setOdds(parseFloat(inputValue, 10));
    }

    handleKeyPressValue = (e) => {
        const { wager } = this.props;

        if (e.key == 'Enter') {
            console.log(parseFloat(e.target.value, 10));

            wager.setValue(parseFloat(e.target.value, 10));
            this.handleClickValue();
        }
    }

    handleKeyPressOdds = (e) => {
        const { wager } = this.props;
        let inputValue = e.target.value * 100;

        if (e.key == 'Enter') {
            console.log(parseFloat(inputValue, 10));

            console.log("odds: " + parseFloat(inputValue, 10));
            wager.setOdds(parseFloat(inputValue, 10));
            this.handleClickOdds();
        }
    }


    onChange = (value) => {
        const { wager } = this.props;
        this.setState({
            inputValue: value,
        });

        wager.setOdds(value);

    }

    onRadioChange = (e) => {
        const { wager } = this.props;
        console.log('radio checked', e.target.value);
        this.setState({
            radioValue: e.target.value,
        });
        if (e.target.value == 1) {
            wager.setOdds(this.state.oneToBlankOddsValue);
        } else {
            wager.setOdds(this.state.blankToOneOddsValue);

        }
    }

    onBlankToOneChange = (value) => {
        const { wager } = this.props;
        console.log(value + " means odds should be " + 100 * value);
        this.setState({
            blankToOneOddsValue: 100 * value,
        });
        wager.setOdds(100 * value);

    }
    onOneToBlankChange = (value) => {
        const { wager } = this.props;
        console.log(value + " means odds should be " + Math.floor(100 / value));
        this.setState({
            oneToBlankOddsValue: Math.floor(100 / value),
        });
        wager.setOdds(Math.floor(100 / value));
    }

    onPrivateSwitchChange(checked, event) {
        //  console.log("the switch is " + checked);
        const { wager } = this.props;
        this.setState({ isPrivate: !checked });
        wager.changePrivacy();
        // console.log("Is Private? " + !checked);

    }

    render() {
        const radioStyle = {
            display: "block",
            height: '30px',
            lineHeight: '30px',
            color: "rgb(255,255,255)"
        };

        const { CustomRouter, wager } = this.props;
        const { router: { goTo } } = CustomRouter;

        let valueInput = <div className="bet-slip-list-bet-value-amount" onClick={this.handleClickValue} style={{ padding: '6px 2px 0px 2px', letterSpacing: '1px' }}>{(wager.value / ethMultiplier).toFixed(4)} ETH</div>
        let oddsInput = <div className="bet-slip-list-bet-value-odds" onClick={this.handleClickOdds} style={{ padding: '6px 0px 0px 0px', letterSpacing: '1px' }}>{(100 / wager.odds).toFixed(2)}</div>


        if (this.state.valueClicked) {
            valueInput = <div className="bet-slip-list-bet-value-amount" style={{ padding: '6px 2px 0px 2px', letterSpacing: '1px' }}>
                {/* <input autoFocus onKeyPress={this.handleKeyPressValue} onBlur={this.handleClickValue} onChange={this.handleValueChange} className="bet-slip-value-input" type="number" value={(wager.value).toFixed(4)} /> */}
                <InputNumber autoFocus
                    // onKeyPress={this.handleKeyPressValue}
                    onBlur={this.handleClickValue} onChange={this.handleValueChange} className="bet-slip-value-input" 
                    // type="number" 
                    defaultValue={(wager.value).toFixed(4)} />
            </div>
        }

        if (this.state.oddsClicked) {
            oddsInput = <div className="bet-slip-list-bet-value-odds" style={{ padding: '6px 0px 0px 0px', letterSpacing: '1px' }}>
                <input autoFocus onKeyPress={this.handleKeyPressOdds} onBlur={this.handleClickOdds} onChange={this.handleOddsChange} className="bet-slip-odds-input" type="number" value={(100 / wager.odds).toFixed(2)}></input>
            </div>
        }
        const { inputValue } = this.state;
        return (

            <li>
                <div className="bet-slip-list-event-title" onClick={() => goTo(NavViews.singleEvent, { eventID: wager.eventId }, CustomRouter)}>
                    {this.state.teamOneName} VS {this.state.teamTwoName}
                </div>
                <div className="bet-slip-list-selected-team">
                    {this.state.propTitle}
                </div>
                <div className="bet-slip-list-selected-team">
                    You Selected <span>{this.state.selectedTeamName}</span>
                </div>
                {/*<div className="bet-slip-list-event-start-time">
                    Starts in <span><Countdown date={wager.eventStartTime * 1000} /></span>
                </div>*/}
                <div className="bet-slip-list-value-odds-wrap">
                    <div className="bet-slip-list-bet-value-wrap">
                        <div className="bet-slip-list-bet-value">
                            Amount to bet
                        </div>
                        <div className="bet-slip-list-bet-value-buttons">
                            <button className="custom-btn-danger" onClick={wager.decrementValue}>-</button>
                            {valueInput}
                            <button className="custom-btn-success" onClick={wager.incrementValue}>+</button>
                        </div>
                        <Switch onChange={this.onPrivateSwitchChange} checkedChildren={<span>PUBLIC <Icon type="notification" /></span>} unCheckedChildren={<span>PRIVATE <FaUserSecret /></span>} defaultChecked />
                    </div>
                    <div className="bet-slip-list-bet-odds-wrap">
                        <div className="bet-slip-list-bet-odds">
                            ODDS<Tooltip title="The amount you are betting is represented by the first number (before the colon).">
                                <Icon type="question-circle" />
                            </Tooltip>
                        </div>
                        {/* <Slider min={0.01} max={100} defaultValue={1} step={0.01} /> */}

                        {/* <div className="bet-slip-list-bet-odds-buttons">
                            <button className="custom-btn-danger" onClick={wager.incrementOdds}>-</button>
                            {oddsInput}
                            <button className="custom-btn-success" onClick={wager.decrementOdds}>+</button>
                        </div> */}

                        {/* <Slider
                                    min={0.01}
                                    max={100}
                                    step={0.01}
                                 
                                    onChange={this.onChange}
                                    value={typeof inputValue === 'number' ? inputValue : 0}
                                /> */}
                        <RadioGroup onChange={this.onRadioChange} value={this.state.radioValue}>
                            <Radio style={radioStyle} value={1}>1 : <span style={{ width: "20px" }}><InputNumber theme="dark" defaultValue={1}
                                onChange={this.onOneToBlankChange}
                                precision={0}
                                min={1}
                                max={10}

                                style={{
                                    fontFamily: "Poppins",
                                    webkitBixSizing: 'border-box',
                                    boxSizing: 'border-box',
                                    margin: 0,
                                    padding: 0,
                                    listStyle: 'none',
                                    position: 'relative',
                                    display: 'inline-block',
                                    padding: '4px 11px',

                                    width: '100%',
                                    height: '26px',
                                    fontSize: '14px',
                                    lineHeight: 1.5,
                                    color: 'rgba(255, 255, 255, 0.65)',
                                    backgroundColor: 'rgba(255, 255, 255, 0)',

                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    borderColor: '#40a9ff'
                                }}
                                disabled={this.state.radioValue == 2
                                } size="small" /></span></Radio>
                            <Radio style={radioStyle} value={2}><InputNumber defaultValue={1}
                                onChange={this.onBlankToOneChange}
                                precision={0}
                                min={1}
                                max={10}
                                style={{
                                    fontFamily: "Poppins",
                                    webkitBixSizing: 'border-box',
                                    boxSizing: 'border-box',
                                    margin: 0,
                                    padding: 0,
                                    listStyle: 'none',
                                    position: 'relative',
                                    display: 'inline-block',
                                    padding: '4px 11px',

                                    width: '100%',
                                    height: '26px',
                                    fontSize: '14px',
                                    lineHeight: 1.5,
                                    color: 'rgba(255, 255, 255, 0.65)',
                                    backgroundColor: 'rgba(255, 255, 255, 0)',

                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    borderColor: '#40a9ff'
                                }}
                                disabled={this.state.radioValue == 1} size="small" /> : 1</Radio>
                        </RadioGroup>
                        {/*                            
                                <InputNumber
                                     min={0.01}
                                     max={100}
                                     step={0.01}   
                                     style={{width:"50%"}}                              
                                    value={inputValue}
                                    onChange={this.onChange}
                                /> */}


                    </div>

                </div>
                <div className="bet-slip-list-potential-win">
                    Fee: <Tooltip title={<span>Paid out of the pot of winnings. 2 - 3 percent depending on dispute.</span>} >
                        {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}
                        <Icon type="question-circle" />
                    </Tooltip> <span>{(((wager.odds < 100 ? ((wager.value * Math.floor(100 / wager.odds)) / ethMultiplier).toFixed(4) : ((wager.value / (wager.odds / 100)) / ethMultiplier).toFixed(4)) * 0.02) + ((wager.value / ethMultiplier).toFixed(4) * 0.02)).toFixed(4)} - {(((wager.odds < 100 ? ((wager.value * Math.floor(100 / wager.odds)) / ethMultiplier).toFixed(4) : (wager.value / (wager.odds / 100)) / ethMultiplier.toFixed(4)) * 0.03) + ((wager.value / ethMultiplier).toFixed(4) * 0.03)).toFixed(4)} ETH</span>
                </div>
                <div className="bet-slip-list-potential-win">
                    Potential Win: <span>{wager.odds < 100 ? ((wager.value * Math.floor(100 / wager.odds)) / ethMultiplier).toFixed(4) : ((wager.value / (wager.odds / 100)) / ethMultiplier).toFixed(4)} ETH</span> minus fee
                </div>
                <div className="bet-slip-list-remove-button">
                    <Icon onClick={wager.remove} type="close-circle" theme="outlined" />
                </div>
            </li>
        );
    }
}

export default observer(BetSlipWager);


// WEBPACK FOOTER //
// ./src/components/layoutComponents/BetSlipWager.js